'use client';

import dynamic from 'next/dynamic';

export const CodeEditorLoader = dynamic(
	() => import('./code-editor').then((mod) => mod.CodeEditor),
	{ ssr: false },
);
